import React, { useState } from 'react'
import styled from 'styled-components'

import Brand from './Brand'
import MenuToggle from './MenuToggle'
import Menu from './Menu'

const Header = () => {
  const [showMenu, setShowMenu] = useState(false)

  return (
    <Wrapper className="header">
      <Container>
        <Brand />
        <MenuToggle showMenu={showMenu} setShowMenu={setShowMenu} />
      </Container>
      <Menu showMenu={showMenu} setShowMenu={setShowMenu} />
    </Wrapper>
  )
}

const Wrapper = styled.header`
  z-index: 100;
  position: fixed;
  width: 100%;
  background: var(--color-primary);
  color: var(--color-text1);

  a::after {
    background: var(--color-light);
  }

  [color-scheme='rwa-light'] & {
    background: var(--color-primary);
    color: var(--color-light);
  }
`

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: var(--max-width);
  margin: 0 auto;
  padding: var(--size-3) var(--padding-x);
`

export default Header
